"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1687],{

/***/ 39181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Breadcrumb; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Breadcrumb = function Breadcrumb(props) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
    css: blockStyle,
    children: props.items.map(function (item, index) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
        css: listStyle,
        children: item.links ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
          css: multiLinkStyle,
          children: item.links.map(function (link, linkIndex) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
              children: [linkIndex > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                css: separatorStyle,
                children: "/"
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: link.url,
                passHref: true,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                  css: linkStyle,
                  children: link.label
                })
              })]
            }, linkIndex);
          })
        }) : item.url && item.label ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: item.url,
          passHref: true,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            css: linkStyle,
            children: item.label
          })
        }) : item.label ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
          css: textStyle,
          children: item.label
        }) : null
      }, index);
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("display:flex;flex-wrap:wrap;list-style:none;padding:0;margin:0;gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var listStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("display:inline-flex;align-items:center;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.body2 */ .Nv.body2, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";&:not(:last-child)::after{content:\"\";width:0.4rem;height:0.4rem;border-top:1px solid currentColor;border-right:1px solid currentColor;transform:rotate(45deg);margin:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom2x */ .D.atom2x, ";opacity:0.5;}" + ( true ? "" : 0),  true ? "" : 0);
var linkStyle =  true ? {
  name: "1g9nf7g",
  styles: "color:inherit;text-decoration:none;&:hover{text-decoration:underline;text-underline-offset:4px;}"
} : 0;
var textStyle =  true ? {
  name: "opde7s",
  styles: "color:inherit"
} : 0;
var multiLinkStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("display:inline-flex;align-items:center;gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var separatorStyle =  true ? {
  name: "1d35m79",
  styles: "color:inherit;opacity:0.5"
} : 0;

/***/ }),

/***/ 2932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ RegionList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var RegionList = function RegionList(props) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("ul", {
    css: blockStyle,
    children: props.listItems.map(function (link, index) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("li", {
        css: listStyle,
        children: link.url ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: link.url,
          passHref: true,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
            css: linkStyle,
            children: link.text
          })
        }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
          css: textStyle,
          children: link.text
        })
      }, index);
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2_5x */ .D.atom2_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom3x */ .D.atom3x, ";padding:0;margin:0;list-style:none;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), "{grid-template-columns:repeat(3, minmax(0, 1fr));}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{grid-template-columns:repeat(4, minmax(0, 1fr));}" + ( true ? "" : 0),  true ? "" : 0);
var listStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("margin:0;padding:0;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body2 */ .Nv.body2, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var linkStyle =  true ? {
  name: "1337jfk",
  styles: "text-decoration:none;color:inherit;&:hover{text-decoration:underline;text-underline-offset:4px;}"
} : 0;
var textStyle =  true ? {
  name: "opde7s",
  styles: "color:inherit"
} : 0;

/***/ }),

/***/ 19454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LpCruiseAdvancedSearchForm; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(87536);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26793);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(47533);
/* harmony import */ var main_javascripts_components_button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95284);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75215);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79169);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36581);
/* harmony import */ var main_javascripts_components_cruise_CruiseDestinationBlock__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14608);
/* harmony import */ var main_javascripts_components_cruise_CruiseDepartureDatePickerBlock__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15953);
/* harmony import */ var main_javascripts_components_cruise_VesselBrandBlock__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15400);
/* harmony import */ var main_javascripts_components_cruise_form_StaysBlock__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(94477);
/* harmony import */ var main_javascripts_components_cruise_CruiseOriginBlock__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(76308);
/* harmony import */ var main_javascripts_components_cruise_VesselBlock__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(57551);
/* harmony import */ var main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(12297);
/* harmony import */ var main_javascripts_components_modal_ModalDialogWithClose__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(575);
/* harmony import */ var main_javascripts_components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(50169);
/* harmony import */ var _lpCruiseSlice__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30125);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(35944);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
































yup__WEBPACK_IMPORTED_MODULE_6__/* .setLocale */ .i_(main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_15__/* .yupDefaultMessages */ .b);
var schema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({});
var LpCruiseAdvancedSearchForm = function LpCruiseAdvancedSearchForm() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_26__/* .useTranslation */ .$)(["component", "label", "button"]),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var defaultValues = {};
  var region = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__/* .useAppSelector */ .CG)(_lpCruiseSlice__WEBPACK_IMPORTED_MODULE_25__/* .regionSelector */ .yq);
  var vessel = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__/* .useAppSelector */ .CG)(_lpCruiseSlice__WEBPACK_IMPORTED_MODULE_25__/* .vesselSelector */ .KN);

  if (region) {
    defaultValues["origin_destination_region_ids"] = [region.id];
    defaultValues["origin_destination_region_names"] = [region.name];
  }

  if (vessel) {
    defaultValues["vessel_code"] = [vessel.code];
    defaultValues["vessel_names"] = [vessel.name];
  }

  var defaultCruiseDestinationSuggestions = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__/* .useAppSelector */ .CG)(main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_22__/* .cruiseDefaultDestinationSuggestionsSelector */ .mf) || [];
  var defaultDestinations = defaultCruiseDestinationSuggestions.map(function (suggestion) {
    return suggestion.region;
  }); // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isDisplayed = _useState[0],
      setIsDisplayed = _useState[1];

  var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_27__/* .useForm */ .cI)({
    mode: "onBlur",
    resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_28__/* .yupResolver */ .X)(schema),
    defaultValues: defaultValues
  });
  var handleSubmit = methods.handleSubmit,
      clearErrors = methods.clearErrors;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    window.addEventListener("resize", onResizeWindow);
    return function () {
      window.removeEventListener("resize", onResizeWindow);
    };
  }, []);

  var onResizeWindow = function onResizeWindow() {
    if (isDisplayed && (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .isDesktop */ .nI)(breakpoint)) {
      (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(false);
    }
  };

  var onClickFilterButton = function onClickFilterButton() {
    displayModal();
  };

  var onClickCloseButton = function onClickCloseButton() {
    hideModal();
  };

  var displayModal = function displayModal() {
    setIsDisplayed(true);
    (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(true);
  };

  var hideModal = function hideModal() {
    setIsDisplayed(false);
    (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(false, 0);
  };

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(values, _) {
      var params, listPagePath;
      return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = (0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(values, {
                arrayFormat: "indices"
              });
              listPagePath = "/cruises?".concat(params);
              hideModal(); // モーダルが閉じてから遷移させている

              setTimeout(function () {
                router.push(listPagePath);
              }, 400);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
      css: buttonBlockStyle,
      onClick: onClickFilterButton,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsxs */ .BX)("div", {
        css: buttonStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
          css: buttonIconStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_24__/* .SvgIcon */ .l, {
            name: "filter"
          })
        }), t("button:common.filterBy")]
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_modal_ModalDialogWithClose__WEBPACK_IMPORTED_MODULE_23__/* .ModalDialogWithClose */ .Tg, {
      displayed: isDisplayed,
      closeHandler: onClickCloseButton,
      maxWidthStyle: "50rem",
      maxHeightStyle: "min(58rem, 90%)",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsxs */ .BX)("div", {
        css: innerStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
          css: titleStyle,
          children: t("component:common.filterBy")
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_27__/* .FormProvider */ .RV, _objectSpread(_objectSpread({}, methods), {}, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsxs */ .BX)("form", {
            css: formStyle,
            onSubmit: handleFormSubmit,
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
              css: scrollBlockStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsxs */ .BX)("div", {
                css: formInnerStyle,
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_CruiseDestinationBlock__WEBPACK_IMPORTED_MODULE_16__/* .CruiseDestinationBlock */ .N, {
                  defaultDestinations: defaultDestinations,
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_CruiseDepartureDatePickerBlock__WEBPACK_IMPORTED_MODULE_17__/* .CruiseDepartureDatePickerBlock */ .e, {
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_VesselBrandBlock__WEBPACK_IMPORTED_MODULE_18__/* .VesselBrandBlock */ .E, {
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_VesselBlock__WEBPACK_IMPORTED_MODULE_21__/* .VesselBlock */ .S, {
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_form_StaysBlock__WEBPACK_IMPORTED_MODULE_19__/* .StaysBlock */ .I, {
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_cruise_CruiseOriginBlock__WEBPACK_IMPORTED_MODULE_20__/* .CruiseOriginBlock */ .j, {
                  borderColorStyleKey: "secondary",
                  fontSizeStyleKey: "small"
                })]
              })
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
              css: submitBlockStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)("div", {
                css: submitButtonStyle,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__/* .jsx */ .tZ)(main_javascripts_components_button_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                  type: "submit",
                  children: t("component:search.apply")
                })
              })
            })]
          })
        }))]
      })
    })]
  });
};
var scrollBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("width:100%;height:100%;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom */ .D.atom, " 72px;overflow-y:auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)( true ? "" : 0,  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("width:8rem;height:2.5rem;display:grid;grid-template-columns:2rem 1fr;align-items:center;justify-items:center;gap:0;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom0_5x */ .D.atom0_5x, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .accentColor.primaryColor */ .z.primaryColor, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_13__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_13__/* .lineHeight.body2 */ .Nv.body2, ";border:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .accentColor.primaryColor */ .z.primaryColor, ";border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_14__/* .borderRadius.normal */ .E.normal, ";background:#fff;box-sizing:border-box;cursor:pointer;transition:color 0.2s ease,border-color 0.2s ease;&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonIconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("width:1.5rem;height:1.5rem;display:flex;align-items:center;justify-content:center;svg{path{fill:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .accentColor.primaryColor */ .z.primaryColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var submitBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom */ .D.atom, ";position:absolute;width:100%;bottom:0;left:0;border-top:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";box-sizing:border-box;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom2x */ .D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var submitButtonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .moreThanBreakpoint */ .h6)("desktop"), "{width:18rem;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle =  true ? {
  name: "kbnfx2",
  styles: "margin:0 auto;position:relative;height:100%;width:100%;display:flex"
} : 0;
var formStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var formInnerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom2x */ .D.atom2x, " 0 11rem;" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_31__.css)("position:absolute;top:-3rem;left:0;width:100%;height:3rem;display:flex;align-items:center;box-sizing:border-box;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_11__/* .space.atom2x */ .D.atom2x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_13__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_13__/* .fontWeight.medium */ .Ue.medium, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";border-top-left-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_14__/* .borderRadius.normal */ .E.normal, ";border-top-right-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_14__/* .borderRadius.normal */ .E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 45417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ LpCruiseFaqList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92788);
/* harmony import */ var remark_breaks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67127);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var LpCruiseFaqList = function LpCruiseFaqList(props) {
  var faqs = props.faqs;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
    css: listStyle,
    children: faqs.map(function (faq) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
        css: listItemStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
          css: questionStyle,
          children: faq.questionText
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
          css: answerStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_markdown__WEBPACK_IMPORTED_MODULE_7__/* .Markdown */ .UG, {
            remarkPlugins: [remark_breaks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z],
            skipHtml: false,
            children: faq.answerText
          })
        })]
      }, faq.id);
    })
  });
};
var listStyle =  true ? {
  name: "3t91zy",
  styles: "display:grid;grid-template-columns:minmax(0, 1fr);gap:3rem"
} : 0;
var listItemStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.body1 */ .Nv.body1, ";border-top:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";padding-top:2.5rem;&:first-of-type{border-top:none;padding-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var questionStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:1.1875rem;line-height:1.4;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";margin-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom4x */ .D.atom4x, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__/* .moreThanBreakpoint */ .h6)("tablet"), "{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.headline */ .JB.headline, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.headline2 */ .Nv.headline2, ";}" + ( true ? "" : 0),  true ? "" : 0);
var answerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.body1 */ .Nv.body1, ";h1{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.headline */ .JB.headline, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.headline2 */ .Nv.headline2, ";margin-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}h2{font-size:1.1875rem;line-height:1.4;margin-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2_5x */ .D.atom2_5x, ";margin-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}h3,h4,h5,h6{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight.mediumHeadline2 */ .Nv.mediumHeadline2, ";margin-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";margin-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}p{margin-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, ";margin-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, ";}ul,ol{margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, " 0;padding-left:1.3em;}a{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";text-decoration:underline;&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";}}strong{font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}pre{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";overflow:auto;font-size:85%;line-height:1.45;background-color:rgb(0 0 0 / 0.04);border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__/* .borderRadius.normal */ .E.normal, ";margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, " 0;code{padding:0;font-size:inherit;background-color:transparent;border-radius:0;}}code{padding:0.2em 0.4em;font-size:85%;background-color:rgb(0 0 0 / 0.04);border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__/* .borderRadius.normal */ .E.normal, ";}hr{background-color:rgb(0 0 0 / 0.1);border:none;margin:1em 0;}blockquote{margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, " 0;padding:0 1em;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";border-left:0.25em solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 75767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LpCruiseIntroduction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_utils_StringUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56896);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);






var LpCruiseIntroduction = function LpCruiseIntroduction(props) {
  var introduction = props.introduction;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    css: blockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      css: introductionStyle,
      children: (0,main_javascripts_utils_StringUtil__WEBPACK_IMPORTED_MODULE_3__/* .nl2br */ .hU)(introduction)
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)( true ? "" : 0,  true ? "" : 0);
var introductionStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight.body1 */ .Nv.body1, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 25345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LpCruiseList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var main_javascripts_components_cruise_CruiseCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18719);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);




var LpCruiseList = function LpCruiseList(props) {
  var cruises = props.cruises;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .Fragment */ .HY, {
    children: cruises.map(function (cruise) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(main_javascripts_components_cruise_CruiseCard__WEBPACK_IMPORTED_MODULE_1__/* .CruiseCard */ .C, {
        cruise: cruise,
        param: {}
      }, cruise.id);
    })
  });
};

/***/ }),

/***/ 89072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ LpCruiseSorterForm; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(16835);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(87536);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26793);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(47533);
/* harmony import */ var main_javascripts_components_button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95284);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75215);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36581);
/* harmony import */ var main_javascripts_components_modal_ModalDialogWithClose__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(575);
/* harmony import */ var main_javascripts_components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50169);
/* harmony import */ var main_javascripts_components_cruise_form_CruiseSorterBlock__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86739);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(79169);
/* harmony import */ var _lpCruiseSlice__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(30125);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(35944);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


























yup__WEBPACK_IMPORTED_MODULE_6__/* .setLocale */ .i_(main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_14__/* .yupDefaultMessages */ .b);
var schema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({});
var LpCruiseSorterForm = function LpCruiseSorterForm(props) {
  var defaultValues = props.defaultValues;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_20__/* .useTranslation */ .$)(["component", "label", "button"]),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var formDefaultValues = defaultValues || {
    sort_by: [{
      sort_name: "price_cents",
      order: "asc"
    }]
  };
  var region = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_18__/* .useAppSelector */ .CG)(_lpCruiseSlice__WEBPACK_IMPORTED_MODULE_19__/* .regionSelector */ .yq);
  var vessel = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_18__/* .useAppSelector */ .CG)(_lpCruiseSlice__WEBPACK_IMPORTED_MODULE_19__/* .vesselSelector */ .KN); // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isDisplayed = _useState[0],
      setIsDisplayed = _useState[1];

  var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .useForm */ .cI)({
    mode: "onBlur",
    resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_22__/* .yupResolver */ .X)(schema),
    defaultValues: formDefaultValues
  });
  var handleSubmit = methods.handleSubmit,
      clearErrors = methods.clearErrors;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    window.addEventListener("resize", onResizeWindow);
    return function () {
      window.removeEventListener("resize", onResizeWindow);
    };
  }, []);

  var onResizeWindow = function onResizeWindow() {
    if (isDisplayed && (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .isDesktop */ .nI)(breakpoint)) {
      (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(false);
    }
  };

  var onClickFilterButton = function onClickFilterButton() {
    displayModal();
  };

  var onClickCloseButton = function onClickCloseButton() {
    hideModal();
  };

  var displayModal = function displayModal() {
    setIsDisplayed(true);
    (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(true);
  };

  var hideModal = function hideModal() {
    setIsDisplayed(false);
    (0,main_javascripts_utils_ScrollUtil__WEBPACK_IMPORTED_MODULE_8__/* .stopBodyScrolling */ .wV)(false, 0);
  };

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(values, _) {
      var sortData, _sortData, sortName, order, _values, params, listPagePath;

      return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sortData = values.sort_by_string.split("__");

              if (sortData.length === 2) {
                _sortData = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(sortData, 2), sortName = _sortData[0], order = _sortData[1];
                _values = {
                  sort_name: sortName,
                  order: order
                };

                if (region) {
                  _values["origin_destination_region_ids"] = [region.id];
                  _values["origin_destination_region_names"] = [region.name];
                }

                if (vessel) {
                  _values["vessel_code"] = [vessel.code];
                  _values["vessel_names"] = [vessel.name];
                }

                params = (0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(_values, {
                  arrayFormat: "indices"
                });
                listPagePath = "/cruises?".concat(params);
                hideModal(); // モーダルが閉じてから遷移させている

                setTimeout(function () {
                  router.push(listPagePath);
                }, 400);
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
      css: buttonBlockStyle,
      onClick: onClickFilterButton,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsxs */ .BX)("div", {
        css: buttonStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
          css: buttonIconStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)(main_javascripts_components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_16__/* .SvgIcon */ .l, {
            name: "sort"
          })
        }), t("button:common.sortBy")]
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)(main_javascripts_components_modal_ModalDialogWithClose__WEBPACK_IMPORTED_MODULE_15__/* .ModalDialogWithClose */ .Tg, {
      displayed: isDisplayed,
      closeHandler: onClickCloseButton,
      maxWidthStyle: "30rem",
      maxHeightStyle: "min(30rem, 90%)",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsxs */ .BX)("div", {
        css: innerStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
          css: titleStyle,
          children: t("component:common.sortBy")
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .FormProvider */ .RV, _objectSpread(_objectSpread({}, methods), {}, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsxs */ .BX)("form", {
            css: formStyle,
            onSubmit: handleFormSubmit,
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
              css: scrollBlockStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
                css: formInnerStyle,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)(main_javascripts_components_cruise_form_CruiseSorterBlock__WEBPACK_IMPORTED_MODULE_17__/* .CruiseSorterBlock */ .M, {
                  hideLabel: true,
                  radioButtonStyle: "large"
                })
              })
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
              css: submitBlockStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)("div", {
                css: submitButtonStyle,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_25__/* .jsx */ .tZ)(main_javascripts_components_button_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                  type: "submit",
                  children: t("component:search.apply")
                })
              })
            })]
          })
        }))]
      })
    })]
  });
};
var scrollBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("width:100%;height:100%;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom */ .D.atom, " 72px;overflow-y:auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)( true ? "" : 0,  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("width:8rem;height:2.5rem;display:grid;grid-template-columns:2rem 1fr;align-items:center;justify-items:center;gap:0;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom0_5x */ .D.atom0_5x, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .accentColor.primaryColor */ .z.primaryColor, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_12__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_12__/* .lineHeight.body2 */ .Nv.body2, ";border:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .accentColor.primaryColor */ .z.primaryColor, ";border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_13__/* .borderRadius.normal */ .E.normal, ";background:#fff;box-sizing:border-box;cursor:pointer;transition:color 0.2s ease,border-color 0.2s ease;&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonIconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("width:1.5rem;height:1.5rem;display:flex;align-items:center;justify-content:center;svg{path{fill:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .accentColor.primaryColor */ .z.primaryColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var submitBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom */ .D.atom, ";position:absolute;width:100%;bottom:0;left:0;border-top:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";box-sizing:border-box;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom2x */ .D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var submitButtonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_9__/* .moreThanBreakpoint */ .h6)("desktop"), "{width:18rem;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle =  true ? {
  name: "kbnfx2",
  styles: "margin:0 auto;position:relative;height:100%;width:100%;display:flex"
} : 0;
var formStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var formInnerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom2x */ .D.atom2x, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_26__.css)("position:absolute;top:-3rem;left:0;width:100%;height:3rem;display:flex;align-items:center;box-sizing:border-box;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_10__/* .space.atom2x */ .D.atom2x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_12__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_12__/* .fontWeight.medium */ .Ue.medium, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_11__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";border-top-left-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_13__/* .borderRadius.normal */ .E.normal, ";border-top-right-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_13__/* .borderRadius.normal */ .E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 24814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ LpCruiseYouTubeVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LpCruiseYouTubeVideo = function LpCruiseYouTubeVideo(props) {
  var youtubeLink = props.youtubeLink; // YouTube URLからビデオIDを抽出

  var getYoutubeVideoId = function getYoutubeVideoId(url) {
    var _match$;

    var match = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(url);
    return (_match$ = match === null || match === void 0 ? void 0 : match[2]) !== null && _match$ !== void 0 ? _match$ : "";
  };

  var videoId = getYoutubeVideoId(youtubeLink);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    css: videoBlockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("iframe", {
      css: videoStyle,
      src: "https://www.youtube-nocookie.com/embed/".concat(videoId),
      title: "YouTube video player",
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    })
  });
};
var videoBlockStyle =  true ? {
  name: "7w2bdj",
  styles: "position:relative;width:100%;aspect-ratio:16/9"
} : 0;
var videoStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("position:absolute;top:0;left:0;width:100%;height:100%;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius.message */ .E.message, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 28048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ir": function() { return /* binding */ pushUrl; }
/* harmony export */ });
/* unused harmony exports getAbsoluteUrl, getBasePath */
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ObjectUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76614);



function getAbsoluteUrl(req) {
  var setLocalhost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var protocol = "https:";
  var host = req ? req.headers["x-forwarded-host"] || req.headers["host"] : window.location.host;

  if (host.indexOf("localhost") > -1) {
    if (setLocalhost) host = setLocalhost;
    protocol = "http:";
  }

  return {
    protocol: protocol,
    host: host,
    origin: protocol + "//" + host
  };
}
function pushUrl(param, router) {
  // console.log(router);
  var path = getBasePath(router.asPath);
  var queryParam = (0,humps__WEBPACK_IMPORTED_MODULE_0__.decamelizeKeys)((0,_ObjectUtil__WEBPACK_IMPORTED_MODULE_2__/* .removeEmpty */ .HO)(param));
  var newUrl = "".concat(path, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(queryParam, {
    arrayFormat: "indices"
  }));

  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  } // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意


  router.push(newUrl, null, {
    shallow: true
  });
}
function getBasePath(url) {
  var pathWithoutHash = url.split("#")[0];
  return pathWithoutHash.split("?")[0];
}

/***/ })

}]);